import Constants from "../constants";
import Actions from "./actions";

const initialState = {
  app: {
    name: "STREAMWELL",
    phone: "+91 79040 37932",
  },
  channels: [],
  servers: [],
  views: {},
  users: [],
  alert: {
    show: false,
    type: "info",
    message: "",
  },
  user: {
    username: "",
    token: null,
    limit: 1,
    access: [],
    email: "",
    server: "",
    admin: false,
    type: Constants.user_type.USER
  },
  refreshChannelFlag: true,
  globalLoader: {
    loading: false,
    message: ''
  }
};

const AppReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case Actions.SET_USER:
      return {
        ...state,
        user: payload,
      };
    case Actions.SET_CHANNEL_LIST:
      return {
        ...state,
        channels: payload,
      };
    case Actions.SET_SERVER_LIST:
      return {
        ...state,
        servers: payload,
      };
    case Actions.SHOW_ALERT:
      return {
        ...state,
        alert: {
          ...payload,
          show: true,
        },
      };
    case Actions.HIDE_ALERT:
      return {
        ...state,
        alert: {
          show: false,
          type: "",
          message: "",
        },
      };
    case Actions.SET_USER_LIST:
      return {
        ...state,
        users: payload,
      };
    case Actions.SET_REFRESH_CHANNEL_FLAG:
      return {
        ...state,
        refreshChannelFlag: !state["refreshChannelFlag"],
      };
    case Actions.SHOW_GLOBAL_LOADER:
      return {
        ...state,
        globalLoader: {
          loading: true,
          message: payload || 'Loading.'
        }
      }
    case Actions.HIDE_GLOBAL_LOADER:
      return {
        ...state,
        globalLoader: {
          loading: false,
          message: ''
        }
      }
    case "logout":
      return initialState;
    default:
      return state;
  }
};

export { initialState };

export default AppReducer;
